import {
  AWS_DOMAIN,
  AWS_POOL_WEB_CLIENT_ID,
  AWS_REGION,
  AWS_USER_POOL_ID,
  AWS_POOL_ID,
  DOMAIN,
  PROTOCOL
} from './config';

const awsConfig = {
  Auth: {
    identityPoolId: `${AWS_POOL_ID}`,
    region: AWS_REGION,
    identityPoolRegion: AWS_REGION,
    userPoolId: AWS_USER_POOL_ID,
    userPoolWebClientId: AWS_POOL_WEB_CLIENT_ID,
    mandatorySignIn: false,
    oauth: {
      domain: AWS_DOMAIN,
      redirectSignIn: `${PROTOCOL}app.${DOMAIN}/idpresponse`,
      redirectSignOut: `${PROTOCOL}app.${DOMAIN}/logout`,
      responseType: 'code'
    },
    cookieStorage: { // comment out this cookieStorage to run on local.
      domain: DOMAIN.match(/^(?:[\s\S]+\.)*([\s\S]+\.[\s\S]+)$/)[1],
      path: '/',
      expires: 1,
      sameSite: 'strict',
      secure: true
    }
  }
};

export default awsConfig;
